import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { WebhookIntegrationRecord } from "../WebhookIntegrationRecord";

export function useWebhookIntegration(webhookEndpointId?: string) {
  const { integrationService } = useDomainServices();

  return useQuery<WebhookIntegrationRecord | null, Error>({
    queryKey: ["webhookEndpointId", webhookEndpointId],
    queryFn: ({ signal }) => {
      if (webhookEndpointId === undefined) {
        return Promise.reject(new Error("Invalid webhookEndpointId"));
      }

      return integrationService.getWebhookIntegration(webhookEndpointId, {
        abortSignal: signal,
      });
    },
    enabled: webhookEndpointId !== undefined,

    // 1 minute until considered stale.
    staleTime: 60000,
  });
}
